import { EnvMicroOrganization } from "lib-klab-core";

export const envOrganizationLocal: EnvMicroOrganization = {
    host: "",
    apiBasePath: "/ms-organization",
    vars: {},
    useMocks: false,
    mock: {
        locations: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
            delete: false,
        },
        workSchedules: {
            getAll: false,
            getById: false,
            create: false,
            update: false,
            delete: false,
        },
        executableVersion: { getCurrent: false },
    },
};

export const envOrganizationDev: EnvMicroOrganization = {
    host: "https://gatewayapi-dev.klab.inclub.world",
    apiBasePath: "/ms-organization",
    vars: {},
    useMocks: false,
};

export const envOrganizationProd: EnvMicroOrganization = {
    host: "https://gatewayapi.klab.inclub.world",
    apiBasePath: "/ms-organization",
    vars: {},
    useMocks: false,
};
